import { useQuery } from '@tanstack/react-query'
import { photosService } from '@/api/services/photos.service'
import { queryKeys } from '@/api/query-keys'
import {
  buildFallbackPhotoEffectRuntimeCatalog,
  buildPhotoEffectRuntimeCatalog,
} from '@/lib/photo-effects/photo-effect-catalog'

export function usePhotoEffectsCatalog(enabled = true) {
  return useQuery({
    queryKey: queryKeys.photos.effectsCatalog(),
    queryFn: async () => {
      const entries = await photosService.getPhotoEffectsCatalog()

      return buildPhotoEffectRuntimeCatalog(entries)
    },
    enabled,
    staleTime: 5 * 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
    placeholderData: buildFallbackPhotoEffectRuntimeCatalog(),
  })
}
